import { api as $axios } from '@/helpers/interceptors'
import { GET_PAYMENT_LIST } from '@/constants/path'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}
const state = () => ({
  data: [],
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getPaymentList({ commit }) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(`${GET_PAYMENT_LIST}`, 'get')
      commit('SET_STATE', {
        key: 'data',
        value: res?.data?.data,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'data', value: [] })
      setUnLoading(commit)
    }
  },
  // eslint-disable-next-line no-empty-pattern
  async updatePayment({}, payload) {
    await $axios(`${GET_PAYMENT_LIST}/${payload.id}`, 'put', {
      title: payload.title,
      short_description_bnn: payload.shortDescriptionBnn,
      on_top_discount_percent_bnn: payload.onTopDiscountPercentBnn,
      short_description_studio7: payload.shortDescriptionStudio7,
      on_top_discount_percent_studio7:
        payload.onTopDiscountPercentStudio7,
      bnn: payload.bnn,
      studio7: payload.studio7,
    })
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
